const isLoggedIn = (state) => {
  if (state.token && state.token.length > 0) {
    return true;
  }
  return false;
};

export default {
  isLoggedIn
};



// WEBPACK FOOTER //
// ./src/store/modules/user/getters.js